
import uuid from 'uuid/v4';
import Context from '../context';
import Channel from '../channel';

const isString = (subject) => {
  return Object.prototype.toString.call(subject) === '[object String]';
};

const arrayLike2Array = (arrayLike) => {
  return Array.prototype.slice.call(arrayLike);
};

class Component {

  get children() {
    return Object.assign({}, this._children);
  }

  constructor(element, context, options) {
    this.element = element;
    this.context = context;
    this.options = options;

    this.channel = null;
    this.uuid = uuid();

    this._children = {};
  }

  /*
  * register a child Component to the component
  *
  * @method registerComponent
  * @param {String} name The name of Component
  * @param {String | HTMLElement} selectorOrElement The CSS selector of target elements or HTMLElement
  * @param {Function} factory The function which return Array<Component>
  * @param {Object} option The option object
  * */
  registerComponent(name, selectorOrElement, factory, options = {}) {

    if(this._children[name]) {
      throw new Error('The name of component is already registered, It must be unique in its siblings');
    }

    const elements = [];

    if(isString(selectorOrElement)) {
      elements.push(...arrayLike2Array(this.element.querySelectorAll(selectorOrElement)));
    } else if(selectorOrElement.nodeType === 1) {
      elements.push(...[selectorOrElement]);
    }


    if(elements.length === 0) {
      return false;
    }

    const context = options.context ? options.context : new Context(options.channelName || name);
    const components = factory(elements, context, options);
    const channel = new Channel(context);

    this._children[name] = {
      components,
      context
    };

    components.forEach(component => {
      component.channel = channel;
      component.didRegisterComponent();
    });

    this.channel.connect(channel);

    return true;

  }

  /*
  * release Component from control of the component
  *
  * ＠method unregisterComponent
  * @param  {String}  name  The name of Component released from this component
  * */
  unregisterComponent(name) {

    if(!this._children[name]) {
      return false;
    }

    const { components, context } = this._children[name];
    const channel = this.channel.channels[context.name];

    components.forEach(component => {
      component.channel = null;
      component.didUnregisterComponent();
    });

    this.channel.disconnect(channel);


    delete this._children[name];

    return true;

  }

  didRegisterComponent() {

  }

  didUnregisterComponent() {

  }

  resize() {

  }

}

export default Component;



// WEBPACK FOOTER //
// ./src/js/app/component/component.js